var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"AcfBlocks"}},[_vm._l((_vm.acfBlocks),function(section,index){return [(section && section.block)?_c(section?.block?.vueComponentName,{key:index,tag:"component",attrs:{"block":JSON.parse(JSON.stringify(section?.block)),"gradient":_vm.gradient}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }